export default {"src":"/_next/static/media/globeIcon.c4d12eca.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};